// Fix for dropdown menu positioning when using keyboard navigation
document.addEventListener('DOMContentLoaded', function() {
  // Add CSS rule for keyboard-focused dropdowns in secondary and tertiary navigation
  var style = document.createElement('style');
  style.innerHTML = `
    .site-navigation--secondary .menu--main-item.keyboard-focus .menu--dropdown {
      margin-top: -5px !important;
    }
    .site-navigation--tertiary .menu--main-item.keyboard-focus .menu--dropdown {
      margin-top: -5px !important;
    }
  `;
  document.head.appendChild(style);
  
  // Dynamic positioning for tertiary navigation dropdown
  function setTertiaryDropdownPosition() {
    const tertiaryNav = document.querySelector('.site-navigation--tertiary');
    if (!tertiaryNav) return;
    
    const navHeight = tertiaryNav.querySelector('.tertiary-wrapper').offsetHeight;
    const announcementBar = document.querySelector('.announcement-bar');
    const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    
    // Calculate the total height (navigation + announcement bar)
    const totalHeight = navHeight + announcementBarHeight;
    
    // Create a style rule to set the dropdown top position dynamically
    const dropdownStyle = document.createElement('style');
    dropdownStyle.innerHTML = `
      .site-navigation--tertiary .menu--dropdown {
        // top: ${totalHeight - 3}px !important;
        top: 120px;
      }
    `;
    document.head.appendChild(dropdownStyle);
  }
  
  // Call the function initially
  setTertiaryDropdownPosition();
  
  // Update on window resize
  window.addEventListener('resize', setTertiaryDropdownPosition);
});
